<script lang="ts">
    interface Props {
        title?: string | null;
        clr?: string;
    }

    let { title = "Alert", clr = "hsl(var(--clr-warning-5))" }: Props = $props();
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon"
    style:--clr={clr}
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path d="M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" />
</svg>

<style lang="scss">
    .icon {
        width: 2rem;
        fill: var(--clr);
    }
</style>
